module.exports = __webpack_public_path__ + "resources/09f257c838a93d47e531e6ddaa1e3e92.png";